import AuthLayout from '../layouts/AuthLayout';

const withAuthLayout = (WrappedComponent) => {
    const WithAuthLayout = (props) => (
        <AuthLayout>
            <WrappedComponent {...props} />
        </AuthLayout>
    );
    return WithAuthLayout;
};

export default withAuthLayout;